module.exports = __webpack_public_path__ + "static/media/PartnerIconFilter.ea266316.svg";